//cardInfoPopup
(function() {
    // base는 기본 있어야된다.
    var filterBase = '<li data-filter-id=""><a href="#">전체<span class="blind"></span></a></li>'; 
    var filterList = '<li data-filter-id = "{{displayObjectNo}}"><a href="#">{{mainTitle}}<span class="blind"></span></a></li>';

    // CSR-4856 [개발][WA][모니터링]1차 심사결과_사업자몰_전시 : 새창열림 : 126, 이미지 alt 추가 : 125
    var itemList = '<li class="list">'+
							    '<div class="list-inner">'+
							        '<a href="{{contentUrl}}" target="{{targetStr}}" data-target="{{targetStr}}" {{#if contentTarget !="01" }}title="{{titleStr}}"{{/if}} data-open-mode="{{openMode}}" class="pc-only">'+
							            '<span class="thumb">'+
							                '<img src="{{pcImageFilePath}}" alt="{{pcImageAlt}}" through="m2ps" loading="lazy">'+
							            '</span>'+
							            '<div class="text">'+
							                '<div class="info">'+
							                    '<span class="partner"><span class="blind">제휴사명</span>{{#raw mainTitle}}</span>'+
							                    '<div class="tit">'+
							                        '<span class="blind">혜택 내용</span>{{#raw subTitle}}'+ 
							                    '</div>'+
							                '</div>'+
							                '<p class="date"><span class="blind">혜택 기간</span>{{periodText}}</p>'+
							            '</div>'+
							        '</a>'+
							        '<a href="{{contentUrl}}" target="{{targetStr}}" data-target="{{targetStr}}" {{#if contentTarget !="01" }}title="{{titleStr}}"{{/if}} data-open-mode="{{openMode}}" class="mo-only">'+
							            '<span class="thumb">'+
							                '<img src="{{mobileImageFilePath}}" alt="{{mobileImageAlt}}" through="m2ps" loading="lazy">'+
							            '</span>'+
							            '<div class="text">'+
							                '<div class="info">'+
							                    '<span class="partner"><span class="blind">제휴사명</span>{{mainTitle}}</span>'+
							                    '<div class="tit">'+
							                        '<span class="blind">혜택 내용</span>{{subTitle}}'+ 
							                    '</div>'+
							                '</div>'+
							                '<p class="date"><span class="blind">혜택 기간</span>{{periodText}}</p>'+
							            '</div>'+
							        '</a>'+
							    '</div>'+
							'</li>';
	
	var b2bAffList = [];
	var dispRows = [];
	var filterRows = [];
	// 임시변수들
    var b2bAffiliateList = {
        init: function() { 
            var self = this;
            self.setting();            
            self.loadData();
            self.bindEvents();
            // 최초 1회 로드
            self.requestData();             
        }, 
        loadData: function() {
        	
        	makeList(b2bAffList);
        	makeFilter();
        	
    		function makeList(datalist){
    			var tmpFilterList = [];
				var tmpLowerObjList = [];    			
    			$.each(datalist , function(idx , dRow){
    				if(dRow.lowerDisplayObjectList != null && dRow.lowerDisplayObjectList.length > 0){
    					$.each(dRow.lowerDisplayObjectList , function(idx , subDatalist){
    						subDatalist.parentNo = dRow.displayObjectNo;
    						if(subDatalist.displayPeriodType == "Y"){
    							var fromDt = "";
    							var endDt = "";
        						if(subDatalist.displayBeginDate != null && subDatalist.displayBeginDate.length > 7)
        							fromDt = subDatalist.displayBeginDate.substring(0,4)+"."+subDatalist.displayBeginDate.substring(4,6)+"."+subDatalist.displayBeginDate.substring(6,8);
        						if(subDatalist.displayEndDate != null && subDatalist.displayEndDate.length > 7)
            						endDt = subDatalist.displayEndDate.substring(0,4)+"."+subDatalist.displayEndDate.substring(4,6)+"."+subDatalist.displayEndDate.substring(6,8);
        						subDatalist.periodText = fromDt + " ~ " + endDt;
    						}else if(subDatalist.displayPeriodType == "N"){
    							subDatalist.periodText = "상시";
    						}else{
    							subDatalist.periodText = "";
    						}
    						if(subDatalist.contentTarget == "01"){
    							subDatalist.targetStr = "_self";
    							subDatalist.openMode = "";
    							subDatalist.titleStr = "";
    						}else if(subDatalist.contentTarget == "02"){
    							subDatalist.targetStr = "_blank";
    							subDatalist.openMode = "outlink";
    							subDatalist.titleStr = "새창열림";
    						}else if(subDatalist.contentTarget == "03"){
    							subDatalist.targetStr = "_blank";
    							subDatalist.openMode = "inAppBrowser";
    							subDatalist.titleStr = "새창열림";
    						}else{
    							subDatalist.targetStr = "_blank";
    							subDatalist.openMode = "";
    							subDatalist.titleStr = "새창열림";
    						} 
    						
    						// 필수 아닌 자료들 validate
    						if(subDatalist.contentUrl == null) subDatalist.contentUrl = "";
    						if(subDatalist.mainTitle == null) subDatalist.mainTitle = "";
    						if(subDatalist.subTitle == null) subDatalist.subTitle = "";
    						if(subDatalist.contentTarget === undefined) subDatalist.contentTarget = "";
    						tmpLowerObjList.push(subDatalist);
    					});
    					delete dRow.lowerDisplayObjectList
        				tmpFilterList.push(dRow);
    				}
    			});
   			
    			filterRows = tmpFilterList;
    			dispRows = tmpLowerObjList;    			
    		}
    		
    		// 전체 는 보여주되 내용이 없으면 그냥 홈가기로.
    		function makeFilter(){
                var $flist = $('ul#affiliateFilter');

                $flist.empty();
                $flist.append(filterBase);
                
                if (filterRows.length > 0) {
                    $.each(filterRows , function(index, item) {
                        $flist.append(vcui.template(filterList, item));
                    });
                }
    		}
        },
        
        setting: function() {
        	// JSON데이터를 세팅.
        	b2bAffList = JSON.parse(affiliteListJSON);
        },

        bindEvents: function() {
            var self = this;
            //BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십 > 1뎁스 탭에 따라 탭컨텐츠 타이틀 변경
			var $tabDepth1 = $('.evt-main-tab-wrap .tabs-wrap-new.flexible-tab.ui_stickyTab');
			$(window).on('eventStickyTabchange',function(){
				var $tabContent = $('.evt-main-tab-wrap').next();
				if( $tabContent.hasClass('tab-contents')){
					$('.blind.content_title').remove();
					var contentTitle = $tabDepth1.find('li.on>a').text().replace('선택됨','');
					contentTitle = '<span class="blind content_title">'+contentTitle+' 제휴혜택 내용 시작</span>';
					$tabContent.prepend(contentTitle);
				}
			}).on('load',function(){
				$(window).trigger('eventStickyTabchange');
			})
		    $tabDepth1.on('stickyTabchange',function(e,_obj){
				$(window).trigger('eventStickyTabchange');
		    });

            $(document).on('click', '#affiliateFilter li', function() {
                self.requestData();
            });
        },

        requestData: function() {
        	var self = this;
        	var filteredList = [];

            var filterId = getActiveFilterId();

            // 전체 ==> 원래리스트로.
            if(filterId == ""){
            	filteredList = dispRows;
            }else{
            	$.each(dispRows , function(idx , rRow){
            		if(rRow.parentNo == filterId) filteredList.push(rRow); 
            	});
            }
            
            function getActiveFilterId(){
                var fId ='';
                $('#affiliateFilter li').each(function() {
                    if ($(this).hasClass('on')) {
                    	fId = $(this).data('filter-id');
                    }
                })
                return fId;
            }

        	self.updateList(filteredList);
        },

        updateList: function(filteredList) { // Moved updateList here
            var $list = $('ul#affiliateList');
            var $noData = $('div.no-data');

            $list.empty();
            if (filteredList.length > 0) {
                $noData.hide();
                $.each(filteredList, function(index, item) {
                    $list.append(vcui.template(itemList, item));                    
                });
            } else {
                $noData.show();
            }
        },
    }

    $(window).ready(function() {
    	b2bAffiliateList.init();
    });

})();
